module.exports = __webpack_public_path__ + "static/gallery16-1ca35d6e889937f5f06ad294ee88483c.png";